import AppLayout from '../common/layouts/appLayout';
import React, { useState } from 'react';
import { Container, Box, Banner } from '../styles/globalStyle';
import { Steps, Layout, Form } from 'antd';
import { theme, CardAnt, Text, ButtonAnt } from '@pfmam/pfmam';
import 'antd/dist/antd.css'; // Ensure Ant Design CSS is imported
import styled, { createGlobalStyle } from 'styled-components';
import { useSelector } from 'react-redux';
import LoadSpinner from '../common/components/LoadingSpinner/LoadSpinner';
import { CreateAccountComponent } from './components/createAccountComponent';
import { useHistory } from 'react-router-dom';
import { Prompt } from 'react-router';
const { Content } = Layout;
const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;

const ContentWrapper = styled(Content)`
  .ant-table {
    border-radius: 4px;
    .ant-table-tbody {
      & > tr {
        cursor: pointer;
        &:hover {
          &.ant-table-row:not(.ant-table-expanded-row) {
            background: linear-gradient(
                0deg,
                rgba(23, 54, 93, 0.07),
                rgba(23, 54, 93, 0.07)
              ),
              ${theme.colors.white};
          }
        }
        & > td {
          padding: 20px 32px;
          &.ant-table-column-sort {
            background: ${theme.colors.transparent};
          }
        }
        &:last-child {
          & > td {
            border-bottom-color: ${theme.colors.transparent};
          }
        }
      }
    }
    .ant-table-thead {
      & > tr {
        & > th {
          background: ${theme.colors.light_grey};
          font-family: 'Inter';
          font-weight: bold;
          line-height: 20px;
          &:not(:last-child) {
            &:not(.ant-table-selection-column) {
              &:not(.ant-table-row-expand-icon-cell) {
                &:not([colspan]) {
                  &::before {
                    background-color: ${theme.colors.transparent};
                  }
                }
              }
            }
          }
        }
      }
    }
    &.ant-table.ant-table-middle {
      .ant-table-thead {
        .ant-table-column-sorters {
          padding: 0;
          .ant-table-column-sorter-inner .anticon {
            color: ${theme.colors.grey_stone};
          }
          .ant-table-column-sorter-up.active,
          .ant-table-column-sorter-down.active {
            color: ${theme.colors.black_sorted};
          }
        }
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
    }
    .sort-space-none {
      .ant-table-column-sorters {
        justify-content: flex-start;
      }
      .ant-table-column-title {
        flex: 0 0 auto;
      }
      &.flex-end {
        .ant-table-column-sorters {
          justify-content: flex-end;
        }
      }
    }
    .ant-avatar {
      min-width: 40px;
    }
  }
  .ant-table-title {
    padding: 0 !important;
  }
  .ant-table {
    &.ant-table-middle {
      .ant-table-tbody {
        .ant-table-wrapper {
          &:only-child {
            .ant-table {
              margin: -19px -32px;
            }
          }
        }
        .ant-table-container {
          .ant-table-tbody {
            .ant-table-row {
              .ant-table-cell {
                padding: 20px 32px;
                background-color: ${theme.colors.grey_faint};
              }
              &:hover {
                .ant-table-cell {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
`;
const CreateAccountContainer = (props) => {
  const history = useHistory();
   if (!props?.location?.state?.canNavigate) {
    history.push("/404");
  }
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [promptEnabled, setPromptEnabled] = useState(true);
  const [isTouched, setIsTouched] = useState(true);
  const [loading, setloading] = useState(false);
  const [isAccountSubmitted, setIsAccountSubmitted] = useState(false);
  const OverrideStyles = createGlobalStyle`
    .ant-steps-label-vertical .ant-steps-item-content {
        display: block;
        width: 172px;
        margin-top: 8px;
        text-align: center;
    }
    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
        background-color:${theme.colors.grey_dark};
    }
        .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description {
        color:${primary_color};
    }
    .ant-steps-item-finish .ant-steps-item-icon {
        border-color:${primary_color};
    }
        .ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {
        border-color:${primary_color};
    }
    .ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon {
        color:${primary_color};
    }
    .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color:${primary_color};
    }

    .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
        background:${primary_color};
        border-color:${primary_color};
    }
    .ant-steps-label-vertical .ant-steps-item-icon {
        display: inline-block;
        margin-left: 65px;
    }
    
    .ant-steps-label-vertical .ant-steps-item-tail {
        margin-left: 80px;
        padding: 3.5px 24px;
    }
    `;
  return (
    <>
      <AppLayout>
      {isAccountSubmitted==false?<Prompt
          when={isTouched && promptEnabled}
          message={JSON.stringify({
            header: 'Discard Changes?',
            content:
              'Changes have not been submitted, leaving this page will result in no change of account or permissions. Are you sure you want to leave this page?',
          })}
        /> :null}  
        <OverrideStyles />
        <ContentWrapper>
          {/* <Banner bgcolor={primary_color} height="80px">
            <Box
              display="flex"
              alignitems="center"
              height="100%"
              minwidth="100%"
              width="100%"
              zindex="3"
              position="relative"
              padding="44px 0 36px 0"
            >
              <Container>
                <Box
                  display="flex"
                  justifycontent="space-between"
                  alignitems="flex-start"
                  margin="0"
                >
                  <Box flex="1" justifycontent="flex-start">
                    <Text
                      color={`${theme.colors.white}`}
                      fontSize="36px"
                      lineheight="44px"
                      label="Open New Account"
                    />
                  </Box>
                </Box>
              </Container>
            </Box>
          </Banner> */}
          <>
            {loading === false ? (
              <>
                <CreateAccountComponent
                  primary_color={primary_color}
                  setIsTouched={setIsTouched}
                  isAccountSubmitted={isAccountSubmitted}
                  setIsAccountSubmitted={setIsAccountSubmitted}
                />
              </>
            ) : (
              <LoadSpinner></LoadSpinner>
            )}
          </>
          <>
          </>
        </ContentWrapper>
      </AppLayout>
    </>
  );
};

export default CreateAccountContainer;